var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[(_vm.isLoading)?_c('div',{staticClass:"row is-loading"},[_vm._v(" Cargando.... ")]):_c('div',{staticClass:"sheet"},[_c('risk-credit-header')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }